<template>
  <div class="our-clients">
    <div class="our-clients-info">
      <div class="feature">
        <img src="/img/ticketing.gif" class="main-img-mobile" alt="" />

        <div class="left-part">
          <h1>See what our ticketing tool can do for you</h1>

          <p>
            Our in-house experts can walk you through everything you need to
            know.
          </p>

          <div class="cta-btn">
            <a href="https://console.helixpay.ph/#/login" class="signup">
              Sign-up for Free
            </a>
            <a
              href="https://dashboard.meetbit.io/meeting/HelixPay"
              class="schedule"
            >
              Schedule Demo
            </a>
          </div>
        </div>

        <div class="right-part">
          <img src="/img/ticketing.gif" class="main-img-web" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.main-img-mobile {
  display: none;
}

#mobileOnly {
  display: none;
}

.our-clients {
  width: 100%;
  background-color: white;
}

.our-clients-info {
  max-width: 71rem;
  padding: 6rem 0;
  margin: auto;
}

.our-clients-info > h1 {
  font-size: 3rem;
  font-weight: 700;
  text-align: center;
  margin: 0;
}

.our-clients-info > p {
  text-align: center;
  font-weight: 600;
  padding-top: 1rem;
  margin: 0;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

.feature {
  display: grid;
  gap: 6rem;
  max-width: 71rem;
  margin: auto;
  padding: 0 2rem;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}

.left-part {
  display: grid;
  gap: 2rem;
}

.left-part h1 {
  font-size: 3rem;
  font-weight: 700;
  margin: 0;
}

.left-part p {
  font-weight: 600;
}

.left-part .cta-btn {
  width: 100%;
  margin: auto;
  display: flex;
}

.left-part .cta-btn a {
  text-align: center;
  margin-top: 10px;
  padding: 1rem;
}

.left-part .signup {
  width: 50%;
  background-color: #ff5f8f;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  padding: 20px 30px;
  border-radius: 5px;
  margin-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.left-part .schedule {
  width: 50%;
  background-color: #25a4e1;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  padding: 20px 30px;
  border-radius: 5px;
  margin-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.left-part .signup:hover {
  background-color: #eb4c7b;
}

.left-part .schedule:hover {
  background-color: #2094ca;
}

.right-part img {
  border-radius: 10px;
  pointer-events: none;
  width: 100%;
  box-shadow: 6px 5px 0px 11px rgba(0, 0, 0, 1);
  -webkit-box-shadow: 6px 5px 0px 11px rgba(0, 0, 0, 1);
  -moz-box-shadow: 6px 5px 0px 11px rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 1200px) {
  .ticketing-features {
    gap: 0;
    padding: 2rem 2rem;
  }

  .ticketing-features div p {
    display: none;
  }

  .ticketing-features img {
    width: 35%;
  }

  .main-img-mobile {
    display: block;
    max-width: 30rem;
    margin: auto;
    border-radius: 10px;
    box-shadow: 6px 5px 0px 11px rgba(0, 0, 0, 1);
    -webkit-box-shadow: 6px 5px 0px 11px rgba(0, 0, 0, 1);
    -moz-box-shadow: 6px 5px 0px 11px rgba(0, 0, 0, 1);
  }

  .main-img-web {
    display: none;
  }

  .feature {
    grid-template-columns: 1fr;
    gap: 4rem;
    padding: 0 2rem;
  }

  .ticketing-features div {
    padding: 1rem 0;
  }

  .left-part {
    text-align: center;
  }

  .left-part .cta-btn {
    width: 70%;
    margin: auto;
  }
}

@media only screen and (max-width: 1050px) {
  .cta-btn {
    margin: auto;
  }
}

@media only screen and (max-width: 650px) {
  .main-page {
    width: 100%;
    height: inherit;
    margin: auto;
    padding: 2rem;
  }

  .our-clients-info h1,
  .left-part h1 {
    font-size: 2rem;
  }

  .main-img-mobile {
    width: 100%;
    margin: auto;
  }

  .left-part .cta-btn {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
  }

  .left-part .signup,
  .left-part .schedule {
    width: 100%;
    margin: auto;
  }
}
</style>
